@let blok = block();

@for (card of blok.cards; track card._uid) {
    <app-tariff-option-card [block]="card"/>
}

